import InvoiceItem from "./invoice-item";
import { CONSUMPTION_TAX_RATE } from "@/preferences";

export default class Invoice {
  id: number = 0;
  invoiceNumber: string = "";
  estimateId: number = 0;
  estimateNumber: string = "";
  projectId: number = 0;
  projectName: string = "";
  projectClientName: string = "";
  title: string = "";
  mention: string = "";
  staffName: string = "";
  status: string = "created";
  statusName: string = "";
  total: number = 0;
  subtotal: number = 0;
  tax: number = 0;
  taxRate: number = CONSUMPTION_TAX_RATE;
  billingDate: string = "";
  dueDate: string = "";
  bankAccount1: string = "";
  bankAccount2: string = "";
  bankAccount3: string = "";
  deposit: number = 0;
  depositRequestedAt: string = "";
  totalWithDeposit: number = 0;
  items: InvoiceItem[] = [];
  printsExcludeTax: boolean = false;
  PaymentDateDisplay: boolean = false;
  dateOfIssue: string = "";
  isAllSelected: boolean = false;
}
